export default __webpack_public_path__ + "static/media/pie-chart.6f981a51.svg";